import apiSlice from '../api/api.slice';
import { CNCModelI } from './cncModel';

export const cncModel = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCNCModels: builder.query<CNCModelI[], string[]>({
      query: (brandIdList) => ({
        url: `/api/v1/cncModel/getModels?${brandIdList.map((id) => `brandId=${id}`).join('&')}`,
        method: 'GET',
      }),
      transformResponse: (response: { models: CNCModelI[] }) => response.models,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['cncModel'],
  endpoints: {
    providesTags: ['cncModel'],
  },
});

export const { useGetCNCModelsQuery, useLazyGetCNCModelsQuery } = cncModel;
